var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2476_13614)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 50,
    height: 50,
    rx: 5,
    fill: "#FDFDFD",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1 40C21.5225 40 21.0281 39.7944 20.6169 39.3831C20.2056 38.9719 20 38.4775 20 37.9V23.2C20 22.6225 20.2056 22.1281 20.6169 21.7169C21.0281 21.3056 21.5225 21.1 22.1 21.1H26.51C26.7375 20.47 27.1181 19.9625 27.6519 19.5775C28.1856 19.1925 28.785 19 29.45 19C30.115 19 30.7144 19.1925 31.2481 19.5775C31.7819 19.9625 32.1625 20.47 32.39 21.1H36.8C37.3775 21.1 37.8719 21.3056 38.2831 21.7169C38.6944 22.1281 38.9 22.6225 38.9 23.2V37.9C38.9 38.4775 38.6944 38.9719 38.2831 39.3831C37.8719 39.7944 37.3775 40 36.8 40H22.1ZM24.2 35.8H31.55V33.7H24.2V35.8ZM24.2 31.6H34.7V29.5H24.2V31.6ZM24.2 27.4H34.7V25.3H24.2V27.4ZM29.45 22.4125C29.6775 22.4125 29.8656 22.3381 30.0144 22.1894C30.1631 22.0406 30.2375 21.8525 30.2375 21.625C30.2375 21.3975 30.1631 21.2094 30.0144 21.0606C29.8656 20.9119 29.6775 20.8375 29.45 20.8375C29.2225 20.8375 29.0344 20.9119 28.8856 21.0606C28.7369 21.2094 28.6625 21.3975 28.6625 21.625C28.6625 21.8525 28.7369 22.0406 28.8856 22.1894C29.0344 22.3381 29.2225 22.4125 29.45 22.4125Z",
    fill: "#004B49"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2476_13614",
    x: 0,
    y: 0,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.52549 0 0 0 0 0.356863 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2476_13614"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2476_13614",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step2.92c40fbfc760d98741f00cd8aff5b12f.svg";
export { ForwardRef as ReactComponent };